import * as React from 'react';
import { memo } from 'react';
import PropTypes from 'prop-types';
import PlotBandLineContext from '../PlotBandLineContext';
import usePlotBandLineLifecycle from './UsePlotBandLineLifecycle';
var PlotLine = /*#__PURE__*/memo(function (props) {
  var plotline = usePlotBandLineLifecycle(props, 'plotLines');
  var children = props.children;
  if (!children && !plotline) return null;
  return /*#__PURE__*/React.createElement(PlotBandLineContext.Provider, {
    value: plotline
  }, children);
});
PlotLine.displayName = 'PlotLine';
export default PlotLine;